var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.value)?_c('em',{staticClass:"text-info"},[_vm._v(_vm._s(_vm.text))]):_c('span',[(_vm.$slots['value'])?[_vm._t("value")]:[_vm._v(_vm._s(_vm.value))]],2)}
var staticRenderFns = []

export { render, staticRenderFns }